<div class="payment-container"
    *ngIf="(noPOSSolution() || canHandlePayments()) && ((paymentHistory && paymentHistory.length > 0) || (jobcard.quote.externalKey && jobcard.quote.externalKey != '0'))">
    <div class="payment-header">
        <div>{{'bikeshop.rentals.booking.payment_status' | translate}}</div>
        <div>
            <hub-button *ngIf="jobcard.quote && jobcard.quote.externalKey && jobcard.quote.externalKey.length > 0 && jobcard.quote.externalKey.length != '0' && canHandlePayments()" [size]="'sm'"
                [style]="'outline'" [disabled]="busySyncing || busyLoading" (buttonClick)="syncPayments()"
                text="{{'bikeshop.rentals.booking.sync_payments'| translate}}"></hub-button>
        </div>
    </div>


    <div class="payment-history-container" *ngIf="paymentHistory && paymentHistory.length > 0">
        <div class="header">
            <div class="sync-status">
                <span style="width: 26px"></span>
            </div>
            <div>{{ 'bikeshop.rentals.booking.payment_method' | translate }}</div>
            <div>{{ 'bikeshop.rentals.booking.payment_date' | translate }}</div>
            <div style="flex: 1.5">{{ 'bikeshop.rentals.booking.identifier' | translate }}</div>
            <div>{{ 'bikeshop.rentals.booking.payment_amount' | translate }}</div>
            <div style="flex: 1.5" *ngIf="hasRefund">{{ 'bikeshop.rentals.booking.refunds' | translate }}</div>
        </div>

        <div *ngFor="let payment of paymentHistory">
            <div class="sync-status">
                <div *ngIf="payment.paymentSentToPOS" class="synced">
                    <daz-icon [name]="'synced'" [size]="'14px'" [color]="'#060931'"
                        pTooltip="{{ 'bikeshop.modal.update_job_card.quote.item-sent-to-pos' | translate }}"></daz-icon>
                </div>
                <div *ngIf="!payment.paymentSentToPOS" class="not-synced">
                    <daz-icon [name]="'not-synced'" [size]="'14px'" [color]="'#060931'"
                        pTooltip="{{ 'bikeshop.modal.update_job_card.quote.item-not-sent-to-pos' | translate }}"></daz-icon>
                </div>
                <!-- <span class="hubtiger-pos-sent" *ngIf="payment.paymentSentToPOS"></span>
                <span class="hubtiger-pos-not-sent" *ngIf="!payment.paymentSentToPOS"></span> -->
            </div>
            <div>{{payment.paymentMethod}}</div>
            <div>{{(payment.createdDate + 'Z') | date : countryData.AngularDateFormat + " h:mm a"}}</div>
            <div style="flex: 1.5">{{payment.paymentMethod === 'STRIPE' || payment.paymentMethod === 'STRIPE-APP' ?
                payment.stripePaymentIntent : '' }}</div>
            <div>{{partner.CurrencySymbol}}{{payment.amountPaid.toFixed(2)}}</div>
            <div style="flex: 1.5" *ngIf="hasRefund">
                <div *ngFor="let refund of payment.refunds" class="refund">
                    <div>{{partner.CurrencySymbol}}{{refund.amountRefunded.toFixed(2)}}</div>
                    <div>{{(refund.createdDate + 'Z') | date : countryData.AngularDateFormat + " h:mm a"}}</div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="busySyncing || busyLoading" style="margin-top: 16px;display: flex;justify-content: center;">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
        </p-progressSpinner>
    </div>

    <div class="sync-button-container">
        <div *ngIf="(jobcard.quote && jobcard.quote.externalKey && canHandlePayments()) || canRefund">
            <hub-button *ngIf="canRefund" [size]="'sm'" [style]="'outline'" (click)="initiateRefund()"
                text="{{'bikeshop.rentals.booking.initiate_refund'| translate}}"></hub-button>
        </div>
    </div>

</div>

<p-toast position="bottom-center" styleClass="hubtiger-toast" key="payment-toast"></p-toast>
